import React from "react";
import "../pages/paymentPage.css";

const Loader = ({message}) => {
  return (
    <div className="loader-wrapper">
      <div>
        <div className="multi-spinner-container">
          <div className="multi-spinner">
            <div className="multi-spinner">
              <div className="multi-spinner">
                <div className="multi-spinner">
                  <div className="multi-spinner">
                    <div className="multi-spinner"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <p className="m-text">{message ? message :" Please wait ..."}</p>
      </div>
    </div>
  );
};

export default Loader;
